/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {disablePaycheckAllocation} from '../api'

export const useMutationDisablePaycheckAllocation = createReactQueryMutationHook('disablePaycheckAllocation', disablePaycheckAllocation)
